<template>
  <generic-list-item
    class="generic-list-item--product"
    :title="item.name"
    :text="computedItemText"
    :translate-badge-text="true"
    :image-url="item.introImage"
    badge-text="justopp.deal.searchListItem.badgeText"
    badge-theme="lead"
    badge-icon="cart"
    :item-route="finalItemRoute">
    <template #actions>
      <router-link v-slot="{ navigate }" :to="finalItemRoute" custom>
        <form-button
          theme="lead"
          icon-end="chevron-inline-end"
          @click="navigateAndRequestClose(navigate)">
          {{ translate("justopp.deal.searchListItem.ctaView") }}
        </form-button>
      </router-link>
    </template>
  </generic-list-item>
</template>

<script>
import GenericListItem from "@/client/applications/justopp/components/items/generic/ListItem.vue";

export default {
  components: {
    GenericListItem,
  },
  props: {
    item: {
      type: Object,
      default: false,
    },
    itemRoute: {
      type: [Object, Boolean],
      default: false,
    },
  },
  emits: ["list-item:request-close"],
  data: function () {
    return {};
  },
  computed: {
    computedItemText() {
      if (this.item.shortIntroText && this.item.shortIntroText != "") {
        return this.item.shortIntroText;
      }
      return this.translateUcFirst("justopp.deal.searchListItem.modelName", {
        modelName: this.item.code,
      });
    },
    finalItemRoute() {
      if (this.itemRoute) {
        return this.itemRoute;
      }

      return { name: "store-deals-dealId", params: { dealId: this.item.id } };
    },
  },
  watch: {
    item: {
      handler(newVal) {
        //console.log("item", newVal);
      },
      immediate: true,
    },
  },
  mounted() {
    console.log(this.item);
  },
  methods: {
    navigateAndRequestClose(navigationFunction) {
      this.$emit("list-item:request-close", { item: this });
      navigationFunction();
    },
  },
};
</script>

<style scoped lang="scss"></style>
